import { Directive, HostBinding } from '@angular/core';

@Directive({
  // tslint:disable:directive-selector
  selector: '[ls-body]'
})
export class BodyDirective {
  @HostBinding('class.cr-text--body') public body = true;
}
